import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import 'antd/dist/reset.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter 
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}
    >
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Register service worker for PWA and offline support
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('🎉 Service Worker registered successfully:', registration.scope);
        
        // Listen for updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // New version available
                console.log('🔄 New version available! Please refresh.');
                
                // You could show a toast notification here
                if (window.showUpdateAvailable) {
                  window.showUpdateAvailable();
                }
              }
            });
          }
        });
      })
      .catch((error) => {
        console.error('❌ Service Worker registration failed:', error);
      });
  });

  // Listen for messages from service worker
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data && event.data.type === 'SYNC_SUCCESS') {
      console.log('✅ Offline data synced:', event.data.message);
      
      // Show success notification
      if (window.showSyncSuccess) {
        window.showSyncSuccess(event.data.message);
      }
    }
  });
}

// Add network status monitoring
let isOnline = navigator.onLine;

const updateNetworkStatus = () => {
  const wasOnline = isOnline;
  isOnline = navigator.onLine;
  
  if (wasOnline !== isOnline) {
    console.log(isOnline ? '🌐 Back online!' : '📴 Gone offline');
    
    // Dispatch custom event for components to listen to
    window.dispatchEvent(new CustomEvent('networkChange', {
      detail: { isOnline }
    }));
    
    // Show network status notification
    if (window.showNetworkStatus) {
      window.showNetworkStatus(isOnline);
    }
  }
};

window.addEventListener('online', updateNetworkStatus);
window.addEventListener('offline', updateNetworkStatus);

// Initial network status check
updateNetworkStatus(); 